import { useState } from "react";
import CustomDropdown from "../../../components/commons/CustomDropDown";
import Filters from "../../immobilier/componnents/Filter";

const CrawlerHeader = ({ filter, setFilter, search, setSearch }) => {
  const dropdownOptions = [
    { value: "", label: "Tout" },
    { value: "actif:ASC", label: "Actif" },
    { value: "actif:DESC", label: "Inactif" },
  ];
  return (
    <div className="d-flex bg-white headerRadius5 headerContainer align-items-center justify-content-between mb-10">
      <div className="d-flex align-items-center gap10 bg-white radius5 px-20 py-2px searchBar">
        <img src="./icons/search.svg" alt="search" height={16} width={16} />
        <input
          type="search"
          placeholder="Recherche avancée"
          className="inputSearch border-0"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      {/*   <div className="d-flex gap10 align-items-center dropdownMenu">
        <p>Trier par</p>
        <CustomDropdown options={dropdownOptions} />
      </div> */}
      {/* <div className="filter d-flex align-items-center gap10">
        <p>Filtrer</p>
        <Filters onApplyFilters={applyFilters} onResetFilters={resetFilters} />
      </div> */}
    </div>
  );
};

export default CrawlerHeader;
